import { apiClient } from './apiClient';

const dataConnectionService = {
    list: async () => {
        const res = await apiClient.get('/data-connections');
        return res.data;
    },

    get: async (id) => {
        const res = await apiClient.get(`/data-connections/${id}`);
        return res.data;
    },

    create: async (data) => {
        const res = await apiClient.post('/data-connections', data);
        return res.data;
    },

    update: async (id, data) => {
        const res = await apiClient.put(`/data-connections/${id}`, data);
        return res.data;
    },

    remove: async (id) => {
        await apiClient.delete(`/data-connections/${id}`);
    },

    listScopes: async (connectionId) => {
        const res = await apiClient.get(`/data-connections/${connectionId}/scopes`);
        return res.data;
    },

    addScope: async (connectionId, data) => {
        const res = await apiClient.post(`/data-connections/${connectionId}/scopes`, data);
        return res.data;
    },

    updateScope: async (connectionId, scopeId, data) => {
        const res = await apiClient.patch(`/data-connections/${connectionId}/scopes/${scopeId}`, data);
        return res.data;
    },

    removeScope: async (connectionId, scopeId) => {
        await apiClient.delete(`/data-connections/${connectionId}/scopes/${scopeId}`);
    },

    getProcessConfigs: async (processoId) => {
        const res = await apiClient.get(`/processos/${processoId}/data-connection-configs`);
        return res.data;
    },

    saveProcessConfig: async (processoId, connectionId, data) => {
        const res = await apiClient.put(
            `/processos/${processoId}/data-connection-configs/${connectionId}`,
            data
        );
        return res.data;
    },

    runExternalQuery: async (cedenteId, payload) => {
        const res = await apiClient.post(`/cedentes/${cedenteId}/external-queries`, payload);
        return res.data;
    },

    listExternalQueries: async (cedenteId, queryType) => {
        const params = queryType ? { query_type: queryType } : {};
        const res = await apiClient.get(`/cedentes/${cedenteId}/external-queries`, { params });
        return res.data;
    },

    getExternalQueryData: async (cedenteId, queryId) => {
        const res = await apiClient.get(`/cedentes/${cedenteId}/external-queries/${queryId}`);
        return res.data;
    },
};

export default dataConnectionService;
